//
//
//
//
//
//

        import * as echarts from 'echarts';
    export default {
        name: "chart",
        data (){
            return{
            }
        },
        props: {
                ratio: {
                        type: Number,
                        default: 0
                },
                dataObj: {
                        type: Object,
                        default() {
                                return {}
                        }
                },
                index: {
                        type: [String, Number],
                        default: 0
                }
        },
        created(){
                this.$nextTick(()=>{
                         this.setChart()
                })
        },
        methods: {
                setChart(){
                        const mainIndex = `main${this.index}`
                        const width = document.querySelector('.main-box').clientWidth;
                        const height = document.querySelector('.main-box').clientHeight;
                        // console.log(document.getElementById(mainIndex))
                        const chartDom = document.getElementById(mainIndex);
                        
                        const lineChart = echarts.init(chartDom);
                        chartDom.style.width = width + 'px';
                        // chartDom.style.height =  '50px';

                       function randomData() {
                            now = new Date(+now + oneDay);
                            value = value + Math.random() * 21 - 10;
                            return {
                                name: now.toString(),
                                value: [
                                [now.getFullYear(), now.getMonth() + 1, now.getDate()].join('/'),
                                Math.round(value)
                                ]
                            };
                            }

                            let data = [];
                            let now = new Date(1997, 9, 3);
                            let oneDay = 24 * 3600 * 1000;
                            let value = Math.random() * 1000;
                            for (var i = 0; i < 1000; i++) {
                            data.push(randomData());
                            }
                            let greenColor = [
                            {
                                offset: 0,
                                color: 'rgb(17,202,161,0.8)'
                            },
                            {
                                offset: 1,
                                color: 'rgb(17,202,161,0.1)'
                            }
                            ]
                            let redColor = [
                            {
                                offset: 0,
                                color: 'rgb(227,85,97,0.8)'
                            },
                            {
                                offset: 1,
                                color: 'rgb(227,85,97,0.1)'
                            }
                            ]
                            let option = {
                            // tooltip: {
                            //   trigger: 'axis',
                            //   formatter: function (params) {
                            //     params = params[0];
                            //     let date = new Date(params.name);
                            //     return (
                            //       date.getDate() +
                            //       '/' +
                            //       (date.getMonth() + 1) +
                            //       '/' +
                            //       date.getFullYear() +
                            //       ' : ' +
                            //       params.value[1]
                            //     );
                            //   },
                            //   axisPointer: {
                            //     animation: false
                            //   }
                            // },
                            xAxis: {
                                show: false,
                                type: 'time',
                                splitLine: {
                                show: false
                                }
                            },
                            yAxis: {
                                show: false,
                                type: 'value',
                                boundaryGap: [0, '100%'],
                                splitLine: {
                                show: false
                                }
                            },
                            series: [
                                {
                                name: 'Fake Data',
                                type: 'line',
                                showSymbol: false,
                                data: data,
                                itemStyle: {
                                    color: this.ratio <= 0 ? '#E35561' : '#11caa1',
                                },
                                areaStyle: {
                                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, this.ratio <= 0 ? redColor : greenColor)
                                },
                                },

                            ]
                            }

                            option && lineChart.setOption(option);
                }
        
            
        },
        mounted(){
        }
}



// WEBPACK FOOTER //
// ./src/components/chart.vue